var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartViewOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.686275,
    y: 0.686275,
    width: 33.6274,
    height: 33.6274,
    rx: 2.7451,
    stroke: "#50605E",
    strokeWidth: 1.37255
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.17651,
    y: 19.2157,
    width: 5.4902,
    height: 10.2941,
    rx: 1.37255,
    fill: "#50605E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0981,
    y: 13.0392,
    width: 5.4902,
    height: 16.4706,
    rx: 1.37255,
    fill: "#50605E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0195,
    y: 6.86273,
    width: 5.4902,
    height: 22.6471,
    rx: 1.37255,
    fill: "#50605E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartViewOutline);
export default __webpack_public_path__ + "static/media/ChartView_Outline.ef63bf8bdb593f88d337cfa121c08dd0.svg";
export { ForwardRef as ReactComponent };